<template>
  <el-container>
    <el-header class="header-long-global">
      <img src="../../assets/logo.svg" class="header-logo" />
    </el-header>
    <el-main>
      <div v-loading="loading" class="sign-frame">
        <h1>{{ $t("changePassword.BackgroundManagementSystem") }}</h1>
        <h3 class="text_center">{{ $t("changePassword.ResetPassword") }}</h3>
        <el-form ref="form" :model="form" label-width="70px">
          <el-form-item class="sign-form" :label="$t('changePassword.Email')">
            <el-input v-model.trim="form.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('changePassword.VerificationCode')">
            <el-row>
              <el-col :span="12">
                <el-input v-model.trim="form.code"></el-input>
              </el-col>
              <el-col :span="12">
                <el-button
                  :type="
                    codeButton == $t('changePassword.GetVerificationCode')
                      ? 'primary'
                      : 'info'
                  "
                  :disabled="
                    codeButton != $t('changePassword.GetVerificationCode')
                  "
                  @click="getCodeOnclick"
                >{{ codeButton }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('changePassword.NewPassword')">
            <el-input
              v-model.trim="form.password"
              :placeholder="$t('changePassword.EnterNewPassword')"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="login-btn"
              type="primary"
              @click="resetPassword"
              round
            >{{ $t("changePassword.ResetPassword") }}</el-button>
          </el-form-item>
        </el-form>
        <div class="text_center">
          <el-link @click="goBack" type="info" class="el-icon-back">
            {{
            $t("changePassword.ReturnHomePage")
            }}
          </el-link>
        </div>
      </div>
      <div class="copyright-text">
        <h5 class="text_center">
          Copyright © {{ new Date().getFullYear() }} Shenzhen IVPS Technology
          Co., Ltd All Rights Reserved.
        </h5>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "ForgotPasswordView",
  data() {
    return {
      loading: false,
      interval: "",
      codeButton: this.$t("changePassword.GetVerificationCode"),
      outTime: 120,
      form: {
        email: "",
        code: "",
        password: ""
      }
    };
  },
  beforeDestroy() {
    // 销毁倒计时
    clearInterval(this.interval);
  },
  methods: {
    getCodeOnclick() {
      if (this.$common.isEmailAvailable(this.form.email) === false) {
        this.$message.error(this.$t("changePassword.EnterCorrentEmail"));
      } else {
        this.loading = true;
        let _me = this;
        let params = {
          email: _me.form.email
        };
        _me.$common
          .httpPost("/api/captcha/email", params)
          .then(res => {
            _me.loading = false;
            if (res.code == "1000000") {
              // console.log(res)
              clearInterval(_me.interval);
              _me.outTime = res.data.countdown;
              _me.codeButton = res.data.countdown + "s";
              _me.countdownCodeTime();
              _me.$message.success(this.$t("changePassword.getVerCodeSuccess"));
            } else {
              _me.$message.error(res.message);
            }
          })
          .catch(err => {
            _me.loading = false;
            if (err && err.message) {
              _me.$message.error(
                this.$t("changePassword.getVerCodeFail") + err.message
              );
              if (err.code == "2000007") {
                clearInterval(_me.interval);
                _me.outTime = err.data.countdown;
                _me.codeButton = err.data.countdown + "s";
                _me.countdownCodeTime();
              }
            }
          });
      }
    },
    countdownCodeTime() {
      let _me = this;
      this.interval = setInterval(function() {
        if (_me.outTime > 0) {
          _me.outTime--;
          _me.codeButton = _me.outTime + "s";
        } else {
          _me.codeButton = this.$t("changePassword.GetVerificationCode");
          clearInterval(_me.interval);
        }
      }, 1000); //反复执行函数本身
    },
    resetPassword() {
      if (this.$common.isEmailAvailable(this.form.email) === false) {
        this.$message.error(this.$t("changePassword.EnterCorrentEmail"));
      } else {
        if (this.form.code.length === 0) {
          this.$message.error(this.$t("changePassword.codeVerEmpty"));
        } else {
          if (this.form.password.length === 0) {
            this.$message.error(this.$t("changePassword.EnterNewPwd"));
          } else {
            this.loading = true;
            let _me = this;
            let params = {
              email: this.form.email,
              code: this.form.code,
              new_password: this.$md5(this.form.password)
            };
            _me.$common
              .httpPost("/api/user/reset/password/email", params)
              .then(res => {
                _me.loading = false;
                if (res.code == "1000000") {
                  _me.$message.success(this.$t("changePassword.ResetSuccess"));
                  _me.$router.go(-1);
                } else {
                  _me.$message.error(res.message);
                }
              })
              .catch(err => {
                _me.loading = false;
                if (err && err.message) {
                  _me.$message.error(
                    this.$t("changePassword.ResetPwdErr") + err.message
                  );
                }
              });
          }
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.header-long-global {
  background-color: black;
  width: 100%;
  text-align: left;
  height: 60px;
}

.sign-frame {
  width: 450px;
  height: 330px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -225px;
  margin-top: -240px;
  /*margin-right: 200px;*/
}

.sign-form {
  margin-top: 50px;
}

.login-btn {
  width: 420px;
  margin-left: -50px;
}

.copyright-text {
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  margin-bottom: 0px;
}
</style>
